<template>
  <div>
    <p class="text-h5">Share a link to your map:</p>

    <v-text-field
      :value="this.url"
      label="Copy the link below, or click/tap the COPY button"
      outlined
      readonly
      hide-details="auto"
    ></v-text-field>
    <v-btn elevation="2" @click="copyUrlToClipboard()">Copy</v-btn>
    {{ copiedText }}
    <br />
    <br />
    <p class="text-h5">Copy this code to embed your map:</p>
    <v-text-field
      :value="this.iframeTxt"
      label="Copy the link below, or click/tap the COPY button"
      outlined
      readonly
      hide-details="auto"
    ></v-text-field>
    <v-btn elevation="2" @click="copyiFrameToClipboard()">Copy</v-btn>
    {{ copiediframe }}
    <br />

    <p class="text-h5 mb-0 mt-4">Email or post to social media:</p>
    <div class="social-links">
      <a :href="this.twitterLink" target="_blank">
        <v-icon large>mdi-twitter</v-icon>
      </a>
      <a :href="this.fbLink" target="_blank">
        <v-icon large>mdi-facebook</v-icon>
      </a>
      <a :href="this.emailLink" target="_blank">
        <v-icon large>mdi-email</v-icon>
      </a>
    </div>

<!--     <div>
      <p class="text-h5 mt-4">Please sign up for our email update list:</p>
      <div v-html='this.$mainConfig.share["email-html"]'></div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ModalShare",
  props: ["url"],
  components: {},
  data: function () {
    return {
      copiedText: "",
      copiediframe:""
    };
  },
  watch: {
    url: function () {
      this.copiedText = "";
      this.copiediframe = "";
    },
  },
  methods: {
    async copyUrlToClipboard() {
      try {
        await navigator.clipboard.writeText(location.href);
        this.copiedText = "Copied!";
      } catch (err) {
        alert("Error in copying text: ", err);
      }
    },
    async copyiFrameToClipboard() {
      try {
        await navigator.clipboard.writeText(`
        <iframe style="border: none; max-width: 100%" width="${this.$mainConfig.share["embed-width"]}" height="${this.$mainConfig.share["embed-height"]} " src="${this.url}"></iframe>
        <br/>
        <a href="${this.url}" target="_blank"> See the full map at https://${this.$mainConfig.state.url} </a>
        `);
        this.copiediframe = "Copied!";
      } catch (err) {
        alert("Error in copying text: ", err);
      }
    },
  },
  computed: {
    twitterLink: function () {
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        location.href
      )}`;
    },
    fbLink: function () {
      return (
        "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(location.href)
      );
    },
    emailLink: function () {
      const subject = encodeURIComponent("Redistricting and You Map");
      const body = encodeURIComponent(
        "I wanted to share this map I made on the CUNY Graduate Center's Redistricting & You website: " +
          location.href
      );

      return `mailto:?subject=${subject}&body=${body}`;
    },
    iframeTxt: function(){
      return `<iframe style="border: none; max-width: 100%" width="${this.$mainConfig.share["embed-width"]}" height="${this.$mainConfig.share["embed-height"]}" src="${this.url}"></iframe>`
    }
  },
};
</script>
<style scoped>
.social-links {
  padding: 10px 0;
  /* width: fit-content; */
  margin: 0 auto;
}
.social-links a {
  text-decoration: none;
}

.social-links .v-icon {
  border: 1px solid lightgrey;
  padding: 2px;
}
</style>
